import React from 'react';
import { useTranslation } from 'next-i18next/pages';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import PrivateOfficeAdvisorIcon from '@/icons/PrivateOfficeAdvisorIcon.svg';
import { TRANSLATION_NAMESPACE } from '@/i18n/config';

import styles from './AgentShopCard.module.css';

export const PrivateOfficeAdvisorBadge = ({ isAmbassador = false }: { isAmbassador?: boolean }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.private_office);
  const text = isAmbassador
    ? t('search.request.access.form.advisor.badge.textAmbassador')
    : t('search.request.access.form.advisor.badge.text');
  return (
    <div className={styles.privateOfficeAdvisorBadge}>
      <PrivateOfficeAdvisorIcon />
      <div className={styles.privateOfficeAdvisorBadgeTextContainer}>
        <Copy className={styles.privateOfficeAdvisorBadgeText} text={t('search.request.access.form.advisor.badge.prefix')} size="s" bold />
        <Copy className={styles.privateOfficeAdvisorBadgeText} text={text} size="s" />
      </div>
    </div>
  );
};
